import { post } from "@/request/http";

// 获取权限列表
export { apiGetAuthList } from "./permissions";

// 获取角色列表
export const apiGetRoleList = p => post("/auth/getRoleList", p);

// 添加修改角色
export const updateRoleInfo = p => post("/auth/updateRoleInfo", p);

// 删除角色
export const deleteRole = p => post("/auth/deleteRole", p);
